import React, { useState } from 'react';
import { api_createPartyAccessory } from '../../../api/catering/partyAccessory';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { myToastWarning } from '../../../helpers/myToast';

interface SubType {
	name: string;
	description: string;
}

const AddAccessories: React.FC = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [image, setImage] = useState<File | null>(null);
	const [name, setName] = useState<string>('');
	const [des, setDes] = useState<string>('');
	const [fromPrice, setFromPrice] = useState<number | string>('');
	const [toPrice, setToPrice] = useState<number | string>('');
	const [customSubTypes, setCustomSubTypes] = useState<SubType[]>([]);
	const [customSubSubTypes, setCustomSubSubTypes] = useState<SubType[]>([]);
	const [customSubSubSubTypes, setCustomSubSubSubTypes] = useState<SubType[]>([]);
	const navigate = useNavigate();

	const handleCustomSubTypeChange = (index: number, field: keyof SubType, value: string) => {
		const newCustomSubTypes = [...customSubTypes];
		newCustomSubTypes[index][field] = value;
		setCustomSubTypes(newCustomSubTypes);
	};

	const handleCustomSubSubTypeChange = (index: number, field: keyof SubType, value: string) => {
		const newCustomSubSubTypes = [...customSubSubTypes];
		newCustomSubSubTypes[index][field] = value;
		setCustomSubSubTypes(newCustomSubSubTypes);
	};

	const handleCustomSubSubSubTypeChange = (
		index: number,
		field: keyof SubType,
		value: string,
	) => {
		const newCustomSubSubSubTypes = [...customSubSubSubTypes];
		newCustomSubSubSubTypes[index][field] = value;
		setCustomSubSubSubTypes(newCustomSubSubSubTypes);
	};

	const handleSubAccessories = () => {
		setCustomSubTypes([...customSubTypes, { name: '', description: '' }]);
	};
	const handleSubSubAccessories = () => {
		setCustomSubSubTypes([...customSubSubTypes, { name: '', description: '' }]);
	};
	const handleSubSubSubAccessories = () => {
		setCustomSubSubSubTypes([...customSubSubSubTypes, { name: '', description: '' }]);
	};

	const create = async () => {
		if (!name) {
			myToastWarning('Please Enter Name');
			return;
		}
		try {
			setLoading(true);

			// Initialize the JSON payload object
			const payload: {
				name: string;
				description: string;
				price: {
					from: Number;
					to: Number;
				};
				subPartyAccessories: {
					name: string;
					description: string;
					subsubPartyAccessories?: {
						name: string;
						description: string;
					}[];
				}[];
			} = {
				name: name,
				description: des,
				price: {
					from: Number(fromPrice),
					to: Number(toPrice),
				},
				subPartyAccessories: [],
			};

			// Build subAccessories array
			customSubTypes.forEach((subAccessories) => {
				const subAccessoryObj: {
					name: string;
					description: string;
					subsubPartyAccessories?: {
						name: string;
						description: string;
					}[];
				} = {
					name: subAccessories.name,
					description: subAccessories.description,
					subsubPartyAccessories: [],
				};

				// Append subSubAccessories if present
				if (customSubSubTypes) {
					customSubSubTypes.forEach((subSubAccessories) => {
						const subSubAccessoryObj: {
							name: string;
							description: string;
						} = {
							name: subSubAccessories.name,
							description: subSubAccessories.description,
						};

						// Push to subSubPartyAccessories if defined
						if (subAccessoryObj.subsubPartyAccessories !== undefined) {
							subAccessoryObj.subsubPartyAccessories.push(subSubAccessoryObj);
						}
					});
				}

				payload.subPartyAccessories.push(subAccessoryObj);
			});

			// Example of the final JSON payload structure
			console.log(payload);

			const res = await api_createPartyAccessory(payload); // Assuming your API call accepts JSON payload

			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 100);
			}
		} catch (error) {
			console.error('Error creating accessories:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<h3>Add Accessories</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Name
				</label>
				<input
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlTextarea1' className='form-label'>
					Description
				</label>
				<textarea
					value={des}
					onChange={(e) => setDes(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlTextarea1'
					rows={3}></textarea>
			</div>
			<div className='mb-3'>
				<label htmlFor='fromPrice' className='form-label'>
					From Price
				</label>
				<input
					id='fromPrice'
					type='number'
					value={fromPrice}
					onChange={(e) => setFromPrice(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					placeholder='Enter from price'
				/>
			</div>

			<div className='mb-3'>
				<label htmlFor='toPrice' className='form-label'>
					To Price
				</label>
				<input
					id='toPrice'
					type='number'
					value={toPrice}
					onChange={(e) => setToPrice(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					placeholder='Enter to price'
				/>
			</div>

			<div className='mb-3'>
				<button onClick={handleSubAccessories} className='btn btn-secondary'>
					Add Sub Accessories
				</button>
			</div>

			{customSubTypes.map((subType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subType.name}
						onChange={(e) => handleCustomSubTypeChange(index, 'name', e.target.value)}
						className='form-control'
						placeholder='Enter sub type name'
					/>
					<input
						value={subType.description}
						onChange={(e) =>
							handleCustomSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub type description'
						style={{ marginTop: '10px' }}
					/>
					<div className='mb-3'>
						<button onClick={handleSubSubAccessories} className='btn btn-secondary'>
							Add Sub Sub Accessories
						</button>
					</div>
				</div>
			))}

			{customSubSubTypes.map((subSubType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subSubType.name}
						onChange={(e) =>
							handleCustomSubSubTypeChange(index, 'name', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub type name'
					/>
					<input
						value={subSubType.description}
						onChange={(e) =>
							handleCustomSubSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub type description'
						style={{ marginTop: '10px' }}
					/>
					<div className='mb-3'>
						<button onClick={handleSubSubSubAccessories} className='btn btn-secondary'>
							Add Sub Sub Sub Accessories
						</button>
					</div>
				</div>
			))}

			{customSubSubSubTypes.map((subSubSubType, index) => (
				<div key={index} className='mb-3' style={{ width: '400px' }}>
					<input
						value={subSubSubType.name}
						onChange={(e) =>
							handleCustomSubSubSubTypeChange(index, 'name', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub sub type name'
					/>
					<input
						value={subSubSubType.description}
						onChange={(e) =>
							handleCustomSubSubSubTypeChange(index, 'description', e.target.value)
						}
						className='form-control'
						placeholder='Enter sub sub sub type description'
						style={{ marginTop: '10px' }}
					/>
				</div>
			))}
			<button
				onClick={create}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default AddAccessories;
